export default __webpack_public_path__ + "static/media/sun-solid.1cf7793f.svg";